/** @format */

import {
	AggregatedRatingModule,
	ReviewBVReviewsModule,
	ReviewHighlightContainerModule,
	ReviewHighlyRatedFeaturesComponent,
	ReviewHighlyRatedFeaturesModalComponent,
	ReviewMultimediaCountComponent,
	ReviewQuestionsAndAnswersV2Module,
	ReviewRatingSummaryStarsModule
} from '@product-reviews';
import {
	BackToSearchResultsModule,
	BreadcrumbModule,
	FeedbackModule,
	PriceModule,
	ProductDescriptionModule,
	ProductImageCarouselModule,
	ProductImageViewerModule,
	ProductInfoSpecsComponent,
	TechSpecsComponent
} from '@pdp/components';
import { ComponentFactory, ComponentFactoryResolver, NgModule } from '@angular/core';
import { HmfAccordionComponent, HmfButtonComponent } from '@dsg-tech/homefield-angular';

import { CommonModule } from '@angular/common';
import { OutOfStockDefaultComponent } from './out-of-stock-default.component';
import { ProductRecommendationsComponent } from '@product-recommendations/components';
import { DynamicProductTemplateModule } from '../shared/dynamic-product-template-module.interface';

@NgModule({
	declarations: [OutOfStockDefaultComponent],
	imports: [
		AggregatedRatingModule,
		BackToSearchResultsModule,
		BreadcrumbModule,
		CommonModule,
		FeedbackModule,
		HmfAccordionComponent,
		HmfButtonComponent,
		PriceModule,
		ProductDescriptionModule,
		ProductImageCarouselModule,
		ProductImageViewerModule,
		ProductInfoSpecsComponent,
		ProductRecommendationsComponent,
		ReviewBVReviewsModule,
		ReviewHighlightContainerModule,
		ReviewHighlyRatedFeaturesComponent,
		ReviewHighlyRatedFeaturesModalComponent,
		ReviewMultimediaCountComponent,
		ReviewQuestionsAndAnswersV2Module,
		ReviewRatingSummaryStarsModule,
		TechSpecsComponent
	],
	providers: []
})
export class OutOfStockDefaultModule
	implements DynamicProductTemplateModule<OutOfStockDefaultComponent>
{
	constructor(private readonly resolver: ComponentFactoryResolver) {}

	public resolveComponentFactory(): ComponentFactory<OutOfStockDefaultComponent> {
		return this.resolver.resolveComponentFactory(OutOfStockDefaultComponent);
	}
}
